export default {
  topicDetail_just_look_essence:'只看精華',
  topicDetail_follow_circle:'關註圈子',
  topicDetail_follow_num:"{transformNum}個關註",
  topicDetail_no_circle_intro:"暫無圈子介紹",
  topicDetail_latest_publish:'按最新發布',
  topicDetail_found:"下架後，可在「我的帖子-我管理的帖子」中找到該內容，並恢復上架，確定要下架嗎？"
}
